import { Component, OnInit } from '@angular/core';
import { SfhSecurityService } from '@sasser/sfh-shared-security';
import { SharedModule } from '../../../app/shared/shared.module';

@Component({
  standalone: true,
  selector: 'login',
  templateUrl: 'login.template.html',
  imports: [SharedModule]
})
export class LoginComponent implements OnInit { 
  constructor(private sfhAuth: SfhSecurityService) {
  }

  ngOnInit(): void {
    this.sfhAuth.login()
  }
}
